import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { loginRegisterPanelBoxPaperSX } from '@/components/content/Header/styles/login/loginRegisterPanel';
import { panelStyles } from '@/components/content/Header/styles/myWishList';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { CDN_BASE_URL, MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

const HELP_URL = '/ayuda';
export const MyWishlistEmptyBox: FC = () => {
	const wishlistPanelLabels = useLocalization('MyWishlistPanel');
	const imageEmptyWishlistUrl = '/assets/img/empty-faves.svg';

	return (
		<>
			<Box
				sx={loginRegisterPanelBoxPaperSX}
				textAlign="center"
				display="flex"
				flexDirection="column"
				gap="15px"
				alignItems="center"
			>
				<Typography variant="bodySubText" component="span" color="grey.500">
					{wishlistPanelLabels.EmptyMessage.t()}
				</Typography>
				<Img
					sx={panelStyles.emptyImage}
					src={CDN_BASE_URL + imageEmptyWishlistUrl}
					alt={'Empty Wishlist'}
				/>
			</Box>
			<Divider />
			<Stack sx={panelStyles.itemContainer}>
				<Linkable href={HELP_URL} sx={panelStyles.itemLink} id="helpRecentlySaved">
					<Box display="flex" alignItems="center">
						<DynamicIcon name={MATERIAL_SYMBOL_ICONS.help} sx={panelStyles.linkColor} />
						<Typography variant="bodyBaseline" sx={panelStyles.itemText}>
							{wishlistPanelLabels.HelpAndFAQ.t()}
						</Typography>
					</Box>
				</Linkable>
			</Stack>
		</>
	);
};
